export const maxNumberOfBankAccount = 3

export const getAddressUser = (user) => {
  return user.total_address ? user.main_address.id : ''
}

export const userGenders = {
  male: {
    label: 'Laki-laki',
    label2: 'Pria',
    value: 'male'
  },
  female: {
    label: 'Perempuan',
    label2: 'Wanita',
    value: 'female'
  }
}

export const defaultUserGender = userGenders.female

export const userFileNames = {
  avatar: 'avatar'
}

export const maxUsernameLength = 30

export const getUserAvatar = (user) => {
  if (user && user.files) {
    return user.files.filter(
      file => file.name === 'avatar'
    )
  } else {
    return []
  }
}
